export default __webpack_public_path__ + "static/media/Dominguez.aa6481b4.jpg";